import React, { FC } from 'react';
import { Button, Modal } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  header: {
    id: 'onboarding_welcomeDisplayingProgress_nonScratchUsers_title',
  },
  description1: {
    id: 'onboarding_welcomeDisplayingProgress_nonScratchUsers_description1',
  },
  description2: {
    id: 'onboarding_welcomeDisplayingProgress_nonScratchUsers_description2',
  },
  start: {
    id: 'onboarding_welcomeDisplayingProgress_nonScratchUsers_CTA',
  },
});

export const LevelBasedPointsModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  progressIndicator?: string;
}> = ({ isOpen, onClose, progressIndicator }) => {
  const intl = useIntl();

  return (
    <Modal darkCloseIcon isOpen={isOpen} handleClose={onClose}>
      <S.ModalContent>
        <S.ModalHeader>{intl.formatMessage(msgs.header)}</S.ModalHeader>
        <S.Description>{intl.formatMessage(msgs.description1)}</S.Description>
        <S.Description>{intl.formatMessage(msgs.description2)}</S.Description>

        <Button buttonSize="medium" buttonType="primary" wide onClick={onClose}>
          {intl.formatMessage(msgs.start)}
        </Button>
        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};
